import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { resolveImg } from "@/lib/api";

const chapters = [
  { n: "01", t: "100% Natural", d: "Ingredientes de origen natural, sin químicos ni aditivos artificiales dañinos." },
  { n: "02", t: "Calidad Certificada", d: "Productos naturales y orgánicos de la más alta calidad, avalados por resultados reales." },
  { n: "03", t: "Bienestar Integral", d: "Soluciones reales para tu salud física, tu energía y tu equilibrio mental." },
  { n: "04", t: "Resultados Reales", d: "Miles de testimonios de personas que transformaron su vida y su cuerpo." },
];

export const About = ({ content }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <>
      {/* Manifesto chapters */}
      <section id="beneficios" data-testid="benefits-section" className="bg-forest-900 text-sand py-24 md:py-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <span className="text-xs tracking-[0.25em] uppercase font-semibold text-terracotta-300">Nuestro compromiso</span>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight mt-4 max-w-3xl leading-[1.05]">
            Belleza consciente y bienestar natural
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px mt-16 bg-sand/10 rounded-2xl overflow-hidden">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="bg-forest-900 p-8 md:p-10 hover:bg-forest-800 transition-colors group"
              >
                <div className="font-serif text-5xl text-terracotta-400/70 group-hover:text-terracotta-400 transition-colors">{c.n}</div>
                <h3 className="font-serif text-2xl mt-6">{c.t}</h3>
                <p className="text-sand/60 mt-3 leading-relaxed text-sm">{c.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About story with parallax */}
      <section id="nosotros" data-testid="about-section" className="bg-sand py-24 md:py-32 overflow-hidden">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div ref={ref} className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-[0_20px_60px_rgba(26,54,38,0.15)]">
            <motion.img
              style={{ y }}
              src={resolveImg(content.about_image)}
              alt="Sobre Oymer Vida Divina"
              className="absolute inset-0 w-full h-[124%] object-cover"
            />
          </div>
          <div>
            <span className="text-xs tracking-[0.25em] uppercase font-semibold text-terracotta-500">Sobre Nosotros</span>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-forest-900 mt-4 leading-[1.05]">
              {content.about_title}
            </h2>
            <p className="text-forest-700/80 leading-relaxed mt-6 text-base md:text-lg">{content.about_text}</p>
            <a
              href={`https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(content.whatsapp_message)}`}
              target="_blank" rel="noreferrer"
              data-testid="about-contact-btn"
              className="inline-flex mt-8 rounded-full bg-forest-900 text-sand px-8 py-4 text-sm font-semibold hover:bg-terracotta-500 transition-colors"
            >
              Contáctame
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
